// extracted by mini-css-extract-plugin
module.exports = {"content":"floatingVideoPreview_content__A9eTi","title":"floatingVideoPreview_title__UnYc4"};